import {ChangeDetectorRef, Component, Inject, OnInit, Renderer2, ViewChild} from '@angular/core';
import {GenericFormGroupComponent} from '../../../../forms/generic-form-group.component';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Student} from '../../../../shared/interface/roster.interface';
import {MatTable, MatTableDataSource} from "@angular/material/table";
import {UserComment} from "../../../../shared/interface/comment.interface";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";

@Component({
    selector: 'app-registrar-staff-ip-grade-registrar',
    templateUrl: './ip-grade-registrar-view-student.component.html',
    styleUrls: ['./ip-grade-registrar-view-student.component.scss']
})
export class IpGradeRegistrarViewStudentComponent extends GenericFormGroupComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<IpGradeRegistrarViewStudentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Student[],
        protected renderer2: Renderer2,
        private changeDetectRef: ChangeDetectorRef
    ) {
        super(renderer2);
    }

    displayedColumns: string[] = [
        'name',
        'studentId',
        'gradeBanner',
        'gradeIGrade'
    ];

    loading: boolean;

    public dataSource: MatTableDataSource<Student>;

    @ViewChild(MatTable) table: MatTable<Array<UserComment>>;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    pagingSizeList: number[] = [];
    numPerPage: number = 25;


    ngOnInit(): void {
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.setDataSource(this.data);
        this.changeDetectRef.detectChanges();
    }

    getPagingSize(totalNumRecords: number): number[] {
        const returnPagingSizeList: number[] = [];
        if (totalNumRecords > this.numPerPage) {
            for (let i = 1; i < totalNumRecords; i++) {
                if (i % this.numPerPage === 0) {
                    returnPagingSizeList.push(i);
                }
            }
        }

        returnPagingSizeList.push(totalNumRecords);

        return returnPagingSizeList.filter((v, i, a) => a.indexOf(v) === i).sort((a, b) => a - b);
    }

    setDataSource(studentList: Student[]) {

        if(studentList?.length == 0){
            return;
        }
        const paginatorBox = document.getElementById('rosterPaginator');
        if (studentList.length > 0) {
            paginatorBox.classList.remove('do-not-show');
        } else {
            paginatorBox.classList.add('do-not-show');
        }

        this.dataSource = new MatTableDataSource<Student>(studentList);

        this.dataSource.sortingDataAccessor = (item: Student, property: string) => {
            switch (property) {
                case 'name':
                    return item.bannerLastName.toLowerCase() + item.bannerFirstName.toLowerCase();
                default:
                    return item[property];
            }
        };
        this.dataSource.sort = this?.sort;
        this.pagingSizeList = this.getPagingSize(studentList?.length);
        this.paginator.pageSizeOptions  = this.pagingSizeList
        this.paginator.pageSize = studentList.length > this.numPerPage ? this.numPerPage : studentList.length;
        if(this.paginator){
            this.dataSource.paginator = this?.paginator;
        }


    }

    onClose() {
        this.dialogRef.close();
    }

    ngOnChanges(){


    }
}
